// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1seoo","col":"styles_col__RYZuN"};